<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="8">
            <a-form-item :label="$t('label.applicationType')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag disabled type="list" v-decorator="['applyType',{'initialValue':'60'}]" :trigger-change="true" dictCode="sqlx" placeholder="请选择申请类型"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.farms')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" @change="handleFarmerChange" v-decorator="['farmCode',validatorRules.farmCode]" :trigger-change="true" dictCode="sys_depart,depart_name,org_code,org_category='5' and del_flag='0'" :placeholder="$t('label.pleaseSelectFarms')"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.feedingLot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" @change="handleContractCodeChange" :dictCode="dictBreedBatchCode" v-decorator="['breedBatchCode',validatorRules.breedBatchCode]" :trigger-change="true"  :placeholder="$t('label.pleaseSelectBatchNo')"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item  :label="$t('label.contractNo')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" @change="handleContractCodeDetailChange"  :dictCode="dictContractCodeCode" v-decorator="['contractCode',validatorRules.contractCode]" :trigger-change="true"  :placeholder="$t('label.pleaseSelectContractNo')" />
              <!--<a-input v-decorator="['contractCode']" placeholder="请输入放养合同号"></a-input>-->
            </a-form-item>
          </a-col>
         <!-- <a-col :span="8">
            <a-form-item label="申请金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['applyAmount',validatorRules.applyAmount]" :placeholder="$t('label.pleaseInputTheApplicationAmount')"  style="width: 100%"/>
            </a-form-item>
          </a-col>-->
          <a-col :span="8">
            <a-form-item :label="$t('label.accountOfTheBank')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['bankAccount',validatorRules.bankAccount]" :placeholder="$t('label.pleaseEnterTheAccountOfTheBank')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.accountDate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectTheDateOfRecording')"  v-decorator="['postDate', {'initialValue': initPostDate, rules: validatorRules.postDate.rules}]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.grower')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" :dictCode="dictPeasantCode" v-decorator="['farmerCode',validatorRules.farmerCode]" :trigger-change="true"  :placeholder="$t('label.pleaseSelectGrower')" />
        <!--      <a-input v-decorator="['peasant']" :dictCode="dictPeasantCode" placeholder="请输入养户"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.applicant')" :labelCol="labelCol" :wrapperCol="wrapperCol">
             <!-- <a-input v-decorator="['applicant']" placeholder="请输入申请人"></a-input>-->
              <j-dict-select-tag
                :triggerChange="true"
                dictCode="sys_user,realname,username,del_flag = '0'"
                v-decorator="['applicant', {'initialValue': initApplyUser, rules: validatorRules.applicant.rules}]"
              />
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.applicationInitiationDate')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date :placeholder="$t('label.pleaseSelectTheDateOfApplicationInitiation')"  v-decorator="['applyTime', {'initialValue': initAccountPeriod, rules: validatorRules.applyTime.rules}]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <!--<a-col :span="8">
            <a-form-item label="最后审批人" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['lastApprover']" placeholder="请输入最后审批人"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="最后审批时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择最后审批时间" v-decorator="['lastApproveTime']" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>-->
          <a-col :span="8">
            <a-form-item :label="$t('label.cooperationModel')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                disabled
                :triggerChange="true"
                dictCode="hzms"
                v-decorator="['cooperMode', {'initialValue': initCooperMode}]"
              />
              <!--<a-input disabled v-decorator="['cooperMode', {'initialValue': initCooperMode}]" dictCode="hzms"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.dividendRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['pbProfitRatio', {'initialValue': initPbProfitRatio}]" :placeholder="$t('label.pleaseEnterThePercentageOfDividends')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.dividendPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['profitPrice', {'initialValue': initProfitPrice}]" :placeholder="$t('label.pleaseEnterTheDividendPrice')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.marketPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number @change="handleOverPriceChange" v-decorator="['marketPrice',validatorRules.marketPrice]" :placeholder="$t('label.pleaseEnterTheMarketPrice')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.exceedingPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['overPrice']" :placeholder="$t('label.pleaseEnterTheExcessPrice')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.stocker')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list"  v-decorator="['managerCode',validatorRules.managerCode]" :trigger-change="true" :dictCode="dictManagerCode" :placeholder="$t('label.pleaseSelectAStocker')" />
              <!--<a-input v-decorator="['managerCode']" placeholder="请输入放养员"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.stockerInCharge')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list"  v-decorator="['inchargeCode',validatorRules.inchargeCode]" :trigger-change="true" :dictCode="dictInchargeCode" :placeholder="$t('label.pleaseSelectThePersonInChargeOfStocking')" />
              <!--<a-input v-decorator="['inchargeCode']" placeholder="请输入放养负责人"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.totalWeight')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number @change="handleProfitAmountChange" v-decorator="['totalWeight',validatorRules.totalWeight]" :placeholder="$t('label.pleaseEnterTheTotalCatchWeight')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item :label="$t('label.dividendAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['profitAmount', {'initialValue': iniProfitAmount}]" :placeholder="$t('label.pleaseEnterTheAmountOfDividends')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
         <!-- <a-col :span="8">
            <a-form-item label="是否有效" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx" placeholder="请选择是否有效"/>
            </a-form-item>
          </a-col>-->
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import moment from "moment"
  import {getCurrentUser} from '@/api/api'

  export default {
    name: 'EfsStlSettleApplyForm',
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
          validatorRules: {
            applyTime: {rules: [{required: true,  message: this.$t('pleaseSelectTheApplicationInitiationTime!')}]},
            farmCode: {rules: [{required: true, message: this.$t('label.pleaseSelectFarms')}]},
            breedBatchCode: {rules: [{required: true, message: this.$t('label.pleaseSelectTheFeedingLot')}]},
            contractCode: {rules: [{required: true, message: this.$t('label.pleaseSelectContractNo')}]},
           /* applyAmount: {rules: [{required: true, message: '请输入申请金额!'}]},*/
            bankAccount: {rules: [{required: true, message: this.$t('label.pleaseEnterTheAccountOfTheBank')}]},
            postDate: {rules: [{required: true, message: this.$t('label.pleaseSelectTheDateOfRecording')}]},
            farmerCode: {rules: [{required: true, message: this.$t('label.pleaseSelectGrower')}]},
            applicant: {rules: [{required: true, message: this.$t('label.pleaseSelectApplicant')}]},
            marketPrice: {rules: [{required: true, message: this.$t('label.pleaseEnterTheMarketPrice')}]},
            managerCode: {rules: [{required: true, message: this.$t('label.pleaseSelectThePersonInChargeOfStocking')}]},
            inchargeCode: {rules: [{required: true, message: this.$t('label.pleaseSelectAStocker')}]},
            totalWeight: {rules: [{required: true, message: this.$t('label.pleaseEnterTheTotalCatchWeight')}]},
        },
        url: {
          add: "/settleBonus/efsStlSettleApply/add",
          edit: "/settleBonus/efsStlSettleApply/edit",
          queryById: "/settleBonus/efsStlSettleApply/queryById",
          queryContract:"/contractManage/efsMdContract/queryContract"
        },
          dictBreedBatchCode:"",
          dictPeasantCode:"",
          dictContractCodeCode:"",
          dictManagerCode:"",
          dictInchargeCode:"",
          initCooperMode:null,
          initPbProfitRatio:null,
          initProfitPrice:null,
          iniProfitAmount:null,
          initApplyUser:null,
          initAccountPeriod: moment(new Date()).format('YYYY-MM-DD'),
          initPostDate:moment(new Date()).format('YYYY-MM-DD'),

      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
        getCurrentUser().then((res) => {
            if (res.success) {
                this.initApplyUser = res.result.username;
            }
        });
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(this.model.id){
            this.dictPeasantCode = "efs_md_farmer,name,code, code = (SELECT t2.farmer_code FROM sys_depart AS t1 LEFT JOIN sys_depart_extend AS t2 ON t1.id = t2.id WHERE t1.org_code ='" + this.model.farmCode + "') and del_flag = 'N'";
            this.dictBreedBatchCode="efs_md_breed_batch,name,code, farm_code = '" + this.model.farmCode + "' and del_flag = 'N'";
            this.dictManagerCode="sys_user,realname,username,username=(SELECT t1.inspector FROM sys_depart t LEFT JOIN sys_depart_extend t1 ON t.id = t1.id  WHERE t.org_code='" + this.model.farmCode + "') and del_flag='0'";
            this.dictInchargeCode="sys_user,realname,username,username=(SELECT t1.sales_manager FROM sys_depart t LEFT JOIN sys_depart_extend t1 ON t.id = t1.id  WHERE t.org_code='" + this.model.farmCode + "') and del_flag='0'";
            this.dictContractCodeCode = "efs_md_contract,name,code, breed_batch_code = '" + this.model.contractCode + "' and del_flag = 'N' and (cooper_mode='10' or cooper_mode='20')  and approval_status='30'";
        }else{
            this.model.farmerCode = '';
            this.model.breedBatchCode = '';
            this.model.managerCode = '';
            this.model.inchargeCode = '';
            this.model.contractCode = '';
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'farmCode','breedBatchCode','contractCode','applyType','bankAccount','postDate','farmerCode','applicant','applyTime','lastApprover','lastApproveTime','cooperMode','pbProfitRatio','profitPrice','marketPrice','overPrice','managerCode','inchargeCode','totalWeight','profitAmount','validFlag'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'farmCode','breedBatchCode','contractCode','applyType','bankAccount','postDate','farmerCode','applicant','applyTime','lastApprover','lastApproveTime','cooperMode','pbProfitRatio','profitPrice','marketPrice','overPrice','managerCode','inchargeCode','totalWeight','profitAmount','validFlag'))
      },
        handleFarmerChange(value) {
            this.dictPeasantCode = "efs_md_farmer,name,code, code = (SELECT t2.farmer_code FROM sys_depart AS t1 LEFT JOIN sys_depart_extend AS t2 ON t1.id = t2.id WHERE t1.org_code ='" + value + "') and del_flag = 'N'";
            this.dictBreedBatchCode="efs_md_breed_batch,name,code, farm_code = '" + value + "' and del_flag = 'N'";
            this.dictManagerCode="sys_user,realname,username,username=(SELECT t1.inspector FROM sys_depart t LEFT JOIN sys_depart_extend t1 ON t.id = t1.id  WHERE t.org_code='" + value + "') and del_flag='0'";
            this.dictInchargeCode="sys_user,realname,username,username=(SELECT t1.sales_manager FROM sys_depart t LEFT JOIN sys_depart_extend t1 ON t.id = t1.id  WHERE t.org_code='" + value + "') and del_flag='0'";
            this.model.farmerCode = '';
            this.model.breedBatchCode = '';
            this.model.managerCode = '';
            this.model.inchargeCode = '';
            this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model, 'farmerCode','breedBatchCode','managerCode','inchargeCode'))
            })
        },
        handleContractCodeChange(value) {
            this.dictContractCodeCode = "efs_md_contract,name,code, breed_batch_code = '" + value + "' and del_flag = 'N' and (cooper_mode='10' or cooper_mode='20') and approval_status='30'";
            this.model.contractCode = '';
            this.$nextTick(() => {
                this.form.setFieldsValue(pick(this.model, 'contractCode'))
            })
        },
        handleContractCodeDetailChange(value) {
            getAction(this.url.queryContract, { contractCode: value }).then(res => {
                if (res.success) {
                    this.initCooperMode=res.result.efsMdContract.cooperMode;
                    this.initPbProfitRatio=res.result.efsMdContractDetail.pbProfitRatio;
                    this.initProfitPrice=res.result.efsMdContractDetail.profitPrice;
                }
            })
        },
        //超出价格计算
        handleOverPriceChange(marketPrice){
          let initOverPrice=Number(marketPrice)-Number(this.form.getFieldsValue().profitPrice);
            this.form.setFieldsValue({
                "overPrice": initOverPrice.toFixed(6),
            });
            if(this.form.getFieldsValue().totalWeight){
                let iniProfitAmount=Number(this.form.getFieldsValue().overPrice)*(Number(this.form.getFieldsValue().pbProfitRatio)/100)*Number(this.form.getFieldsValue().totalWeight);
                this.form.setFieldsValue({
                    "profitAmount": iniProfitAmount.toFixed(2),
                });
            }else{
                this.form.setFieldsValue({
                    "profitAmount": 0,
                });
            }

        },
        //分红金额计算
        handleProfitAmountChange(totalWeight){
          if(this.form.getFieldsValue().overPrice==undefined){
              this.form.setFieldsValue({
                  "profitAmount": 0,
              });
          }else{
              let iniProfitAmount=Number(this.form.getFieldsValue().overPrice)*(Number(this.form.getFieldsValue().pbProfitRatio)/100)*Number(totalWeight);
              this.form.setFieldsValue({
                  "profitAmount": iniProfitAmount.toFixed(2),
              });
          }

         },
    }
  }
</script>